import React from 'react';
import PropTypes from 'prop-types';
import { colorsModeUI } from '../modeUI';
import { SIZE_MEDIUM } from '../constants';
import UiButton from '../uiButton';
import './index.css';

export const TYPE_FILE = 'TYPE_FILE';
export const STATE_BUTTON_MULTI_STATE_DISABLED = 'DISABLED';
export const STATE_BUTTON_MULTI_STATE_ENABLED = 'ENABLED';
export const STATE_BUTTON_MULTI_STATE_ACTIVED = 'ACTIVED';
export const STATE_BUTTON_MULTI_STATE_ACTIVE_AND_DISABLED =
  'ACTIVE_AND_DISABLED';

/**
 * Ui Button multistate
 * Display a button with 3 styles: disable, enable and active (by active the positive color is used)
 * This component used the UiButton component with the props variable primary = true
 * Props (parameters)
 * @param string id
 * @param bool showLabels
 * @param string sizeButton
 * @param string state = [STATE_BUTTON_MULTI_STATE_DISABLED, STATE_BUTTON_MULTI_STATE_ENABLED,
 *                       STATE_BUTTON_MULTI_STATE_ACTIVED]
 * @param string label
 * @param func onClick
 * @param string iconName
 * @param bool fluid
 * @param string mode
 */
export default class UiButtonMultiState extends React.PureComponent {
  render() {
    const {
      id,
      state,
      showLabels,
      sizeButton,
      label,
      onClick,
      iconName,
      mode,
      fluid,
    } = this.props;
    const style = {};
    if (mode) {
      const modeColors = colorsModeUI(mode);
      if (
        state === STATE_BUTTON_MULTI_STATE_ACTIVED ||
        state === STATE_BUTTON_MULTI_STATE_ACTIVE_AND_DISABLED
      ) {
        style.color = modeColors.BUTTON_MULTISTATE_ACTIVE_COLOR;
      }
    }
    const className =
      state === STATE_BUTTON_MULTI_STATE_ACTIVED ||
      state === STATE_BUTTON_MULTI_STATE_ACTIVE_AND_DISABLED
        ? 'ui-button-multistate-active'
        : '';
    let buttonView = (
      <UiButton
        id={id}
        showLabels={showLabels}
        sizeButton={sizeButton}
        label={label}
        onClick={onClick}
        primary
        iconName={iconName}
        fluid={fluid}
        mode={mode}
      />
    );
    if (
      state === STATE_BUTTON_MULTI_STATE_DISABLED ||
      state === STATE_BUTTON_MULTI_STATE_ACTIVE_AND_DISABLED
    ) {
      buttonView = (
        <buttonView.type {...buttonView.props} {...{ disabled: true }} />
      );
    } else {
      buttonView = (
        <buttonView.type {...buttonView.props} {...{ disabled: false }} />
      );
    }

    return (
      <div className={className} style={style}>
        {buttonView}
      </div>
    );
  }
}

UiButtonMultiState.propTypes = {
  id: PropTypes.string.isRequired,
  showLabels: PropTypes.bool,
  sizeButton: PropTypes.string,
  state: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  iconName: PropTypes.string.isRequired,
  fluid: PropTypes.bool,
  mode: PropTypes.string,
};

UiButtonMultiState.defaultProps = {
  showLabels: true,
  sizeButton: SIZE_MEDIUM,
  state: STATE_BUTTON_MULTI_STATE_ENABLED,
  label: null,
  onClick: null,
  fluid: false,
  mode: null,
};
